export default __webpack_public_path__ + "alberta-birthday.aecf0263aa805839598f.svg";